import React from 'react';

export default function ConfirmModal({
  show,
  onClose,
  onConfirm,
  message = 'Are you sure?',
}) {
  if (!show) return null;
  return (
    <div className='enhanced-image-modal' style={{ zIndex: 2000 }}>
      <div
        className='enhanced-modal-content'
        style={{
          minWidth: 320,
          background: 'white',
          color: '#222',
          padding: 32,
          borderRadius: 16,
          textAlign: 'center',
          position: 'relative',
        }}
      >
        <h4 style={{ marginBottom: 24 }}>{message}</h4>
        <div style={{ display: 'flex', justifyContent: 'center', gap: 16 }}>
          <button
            className='btn btn-danger'
            onClick={onConfirm}
            style={{ minWidth: 90 }}
          >
            Delete
          </button>
          <button
            className='btn btn-light'
            onClick={onClose}
            style={{ minWidth: 90 }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
